export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getNds: () => {
            return new Promise((resolve, reject) => {
                axios
                    .get('/admin/settings/nds')
                    .then(res => {
                        resolve({ enabled: res.data.nds_enabled, amount: res.data.nds_amount })
                    })
                    .catch(err => {
                        console.error(err)
                        reject(err)
                    })
            })
        },
        setNds: ({ commit }, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .post('/admin/settings/nds', {
                        enabled: payload.enabled,
                        amount: parseFloat(Number(payload.amount).toFixed(2))
                    })
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(err => {
                        console.error(err)
                        reject(err)
                    })
            })
        },
        getWithdrawalFee: () => {
            return new Promise((resolve, reject) => {
                axios
                    .get('/admin/settings/withdrawal-fee')
                    .then(res => {
                        resolve({ withdrawal_fee: res.data.withdrawal_fee })
                    })
                    .catch(err => {
                        console.error(err)
                        reject(err)
                    })
            })
        },
        setWithdrawalFee: ({ commit }, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .post('/admin/settings/withdrawal-fee', {
                        withdrawal_fee: parseFloat(Number(payload.withdrawal_fee).toFixed(2))
                    })
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(err => {
                        console.error(err)
                        reject(err)
                    })
            })
        },
    },
};
